import React from "react";
import classNames from "classnames";
import Loader from "../Loader/Loader";

interface Button {
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
}

const Button: React.FC<Button> = (props: Button) => {
  const { children, className, loading } = props;

  const buttonClassNames = classNames({
    [`${className}`]: className,
    "--disabled --with-loader": loading,
  });

  return (
    <button type="submit" className={buttonClassNames}>
      {children}
      {loading && <Loader className="--small --inline ml-4" />}
    </button>
  );
};

export default Button;
